import { useToast as useToastification } from '@/plugins/toast'

interface Toast {
  (message: string): void
  error(message: string): void
  warning(message: string): void
}

export const useToast = () => useToastification()
